import { render } from "./GainConfigurationCard.vue?vue&type=template&id=0c1ab612&scoped=true&ts=true"
import script from "./GainConfigurationCard.vue?vue&type=script&lang=ts"
export * from "./GainConfigurationCard.vue?vue&type=script&lang=ts"

import "./GainConfigurationCard.vue?vue&type=style&index=0&id=0c1ab612&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c1ab612"]])

export default __exports__